/* eslint-disable react-hooks/exhaustive-deps */
import { IGRequest, IGResponse } from "@common/models";
import { INews } from "@common/models/CMS";
import Alert from "@components/general/Alert";
import Button from '@components/general/form/Button';
import NewsItem from '@components/NewsItem';
import { IViewport } from "@config/appConfig";
import { IAppState } from "@misc/State";
import Config from "@service/Config";
import { NEWS, useApolloQuery } from "@service/graphql";
import Translate from "@service/Translate";
import { FC, useEffect, useState } from "react";
import { useSelector } from "react-redux";

const News: FC = () => {
  const { tr } = Translate;
  const { large } = Config.get<IViewport>("viewport");
  const { width } = useSelector((state: IAppState) => ({ width: state.windowWidth }));
  const takeNewsItem: number = width > large ? 6 : 4;
  const [dataState, setDataState] = useState<boolean>(false);
  const [newsList, setNewsList] = useState<INews[]>([]);
  const [skipDataState, setSkipDataState] = useState<IGRequest>({ first: takeNewsItem + 1, skip: 0 });
  const { loading, error, data } = useApolloQuery<IGResponse<INews[]>>(NEWS, {
    variables: {
      first: skipDataState.first,
      skip: skipDataState.skip
    }
  });

  useEffect(() => {
    if (data) {
      const [validData, dataStatus] = controlData<INews>(data.news, takeNewsItem);
      setNewsList(newsList.concat(validData || []));
      setDataState(dataStatus);
    }
  }, [data]);

  const loadMore = () => {
    setSkipDataState((previousState) => ({ first: previousState.first, skip: previousState.skip + takeNewsItem }));
  }

  return (
    <main className="news">
      <div className="container">
        {
          error ? <Alert type="danger" variant="contain" title={tr("err_get_data")} /> :
            <>
              <h2 className="news-header title-border-bottom">
                {tr("news_and_announcements")}
              </h2>
              <article className="row flex spa-2">
                {
                  newsList.map((news, index) =>
                    <div key={index} className="col-1-3 col-sm-1-1 col-md-1-2 col-lg-1-2 news-item">
                      <NewsItem news={news} />
                    </div>
                  )
                }
              </article>
            </>

        }
      </div>
      {
        dataState ?
          <div className="more-btn-container">
            <Button
              onClick={loadMore}
              text={tr("record_load_more")}
              variant="outlined"
              color="primary"
              width="200px"
              height="40px"
              icon="icon-chevron-down"
              iconPositin="end"
              loading={loading}
              className={dataState ? "" : "hide"}
            />
          </div> : ""
      }
    </main>
  )
}

export default News;

export function controlData<T>(items: T[], takeNewsItem: number): [T[], boolean] {
  if ((items?.length) === takeNewsItem + 1) {
    const remainedData = items?.slice(0, takeNewsItem);
    const analyseData = true
    return [remainedData, analyseData]
  } else {
    const remainedData = items
    const analyseData = false
    return [remainedData, analyseData]
  }
}
